module.exports = __webpack_public_path__ + "static/img/tit2.2462d2a0.png";